/* eslint-disable import/no-named-as-default-member */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable react/no-unknown-property */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
/* eslint-disable react/style-prop-object */
import React, {
    useState, useCallback, useEffect, useContext,
    useRef,
} from 'react';
import { ThreeDots } from 'react-loader-spinner';
import { distributorService } from '../../service/distributor.service';
import HeaderContext from '../../Components/Context/HeaderContext';
import CreditDebitListing from './CreditDebitListing';
import CreditDebitListSkeleton from './listSkeleton';
import Pagination from '../../Components/Pagination';
import FilterModal from './Modals/filterModal';
import EmptyScreen from '../../Components/GlobalEmplyPage';

function ManageCreditDebitDetails() {
    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
    } = useContext(HeaderContext);
    const [creditDebitList, setCreditDebitList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const [emptyData, setEmptyData] = useState(false);
    const [totalPage, setTotalPage] = useState('');
    const [sortType, setsortType] = useState('AR_DATE+desc');
    const [searchValue, setsearchValue] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [filterValue, setfilterValue] = useState('');
    const [filterModal, setFilterModal] = useState(false);
    const [Filter, setFilter] = useState({
        transaction_type: [],
        date_range: [],
        customer_code: [],
        org_code: [],
    });
    const [selected, setselected] = useState({
        start_date: '',
        end_date: '',
    });
    const [exportClick, setexportClick] = useState(false);
    const [exportSelected, setexportSelected] = useState('');
    const [exportLoading, setExportLoading] = useState(null);

    const handleFetchCreditDebitDetails = useCallback((page, search, filter) => {
        distributorService.CreditDebitDetailsList(page, search, filter).then((resp) => {
            if (resp.error === false && resp.data.success_status) {
                if (resp?.data?.data?.length === 0) {
                    setLoading(false);
                    setEmptyData(true);
                } else {
                    setEmptyData(false);
                    setLoading(false);
                }
                setCreditDebitList(resp.data.data);
                setCurrentPage(resp.data.current_page);
                setTotalPage(resp.data.number_of_pages);
            } else {
                setLoading(false);
            }
        });
    }, []);

    const handlePageClick = async (data) => {
        setLoading(true);
        const page = data.selected + 1;
        setCurrentPage(page);
    };

    const handleFilter = (filterUrl) => {
        if (filterValue !== filterUrl) {
            setLoading(true);
            setCurrentPage(1);
            setfilterValue(filterUrl);
        } else {
            setLoading(false);
            setfilterValue(filterUrl);
        }
    };
    const buttonRef = useRef(null);

    useEffect(() => {
        // Function to handle clicks outside the button
        function handleClickOutside(event) {
            if (buttonRef.current && !buttonRef.current.contains(event.target)) {
                setexportClick(false);
            }
        }

        // Add event listener to detect clicks outside the button
        document.addEventListener('mousedown', handleClickOutside);

        // Cleanup the event listener when the component is unmounted
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [buttonRef]);

    function isExceedingSixMonths(date1, date2) {
        const startDate = new Date(date1);
        const endDate = new Date(date2);

        // Calculate the total days difference
        const daysDiff = (endDate - startDate) / (1000 * 60 * 60 * 24);

        // If the difference exceeds 183 days (approximately 6 months), return true
        return daysDiff > 183;
    }
    const showExport = () => {
        if (creditDebitList.length === 0 || emptyData) {
            SetErrorMessage('No data available to export');
            setcolorValue('warning');
            setTimeout(() => {
                SetErrorMessage('');
                setcolorValue(false);
            }, 2000);
            return;
        }
        if (!filterValue.includes('date_range') || !selected?.start_date || !selected?.end_date) {
            SetErrorMessage('Please select a date range');
            setcolorValue('warning');
            setTimeout(() => {
                SetErrorMessage('');
                setcolorValue(false);
            }, 2000);
            return;
        }
        if (filterValue.includes('date_range') && isExceedingSixMonths(selected?.start_date, selected?.end_date)) {
            SetErrorMessage('Date range should not exceed 6 months');
            setcolorValue(true);
            setTimeout(() => {
                SetErrorMessage('');
                setcolorValue(false);
            }, 2000);
            return;
        }
        setexportClick(!exportClick);
    };
    useEffect(() => {
        if (searchValue === debouncedSearch) return undefined;
        const timer = setTimeout(() => {
            setLoading(true);
            setDebouncedSearch(searchValue);
            setCurrentPage(1);
        }, 500);
        return () => clearTimeout(timer);
    }, [searchValue, debouncedSearch]);

    const isFirstListChange = useRef(true);
    useEffect(() => {
        if (isFirstListChange.current) {
            isFirstListChange.current = false;
            return;
        }
        setLoading(true);
    }, [currentPage, sortType]);

    const handleExport = useCallback((exportType) => {
        if (!selected?.start_date || !selected?.end_date) {
            SetErrorMessage('Please select a date range');
            setcolorValue('warning');
            setTimeout(() => {
                SetErrorMessage('');
                setcolorValue(false);
            }, 2000);
            return;
        }
        if (isExceedingSixMonths(selected?.start_date, selected?.end_date)) {
            SetErrorMessage('Date range should not exceed 6 months');
            setcolorValue(true);
            setTimeout(() => {
                SetErrorMessage('');
                setcolorValue(false);
            }, 2000);
            return;
        }
        setExportLoading(exportType);
        distributorService.ExportCreditDebitDetails(exportType, selected, filterValue, debouncedSearch).then((val) => {
            if (val.error === false && val.data.success_status) {
                SetSuccessMessage(val.data.message || 'Export initiated successfully');
                setcolorValue(false);
                setexportClick(false);
                setexportSelected('');
                setExportLoading(null);
                if (val.data.url) {
                    window.open(val.data.url, '_blank');
                }
                setTimeout(() => {
                    SetSuccessMessage('');
                }, 3000);
            } else {
                SetErrorMessage(val.data?.message || 'Export failed. Please try again.');
                setcolorValue(true);
                setExportLoading(null);
                setTimeout(() => {
                    SetErrorMessage('');
                    setcolorValue(false);
                }, 3000);
            }
        }).catch((error) => {
            SetErrorMessage('Export failed. Please try again.');
            setcolorValue(true);
            setExportLoading(null);
            setTimeout(() => {
                SetErrorMessage('');
                setcolorValue(false);
            }, 3000);
        });
    }, [selected, filterValue, debouncedSearch, SetErrorMessage, SetSuccessMessage, setcolorValue]);

    useEffect(() => {
        if (exportSelected !== '') {
            handleExport(exportSelected);
        }
    }, [exportSelected, handleExport]);

    const isInitialMount = useRef(true);

    useEffect(() => {
        distributorService.CreditDebitDetailsList(1).then((resp) => {
            if (resp.error === false && resp.data.success_status) {
                if (resp?.data?.data?.length === 0) {
                    setLoading(false);
                    setEmptyData(true);
                } else {
                    setEmptyData(false);
                    setLoading(false);
                }
                setCreditDebitList(resp.data.data);
                setCurrentPage(resp.data.current_page);
                setTotalPage(resp.data.number_of_pages);
            } else {
                setLoading(false);
            }
        });
    }, []);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
        } else {
            handleFetchCreditDebitDetails(currentPage, debouncedSearch, filterValue);
        }
    }, [currentPage, debouncedSearch, filterValue, handleFetchCreditDebitDetails]);

    return (
        <div className="py-6 main-screen">
            <div className="flex justify-between items-center top-0 left-0 pb-[18px]">
                <h5 className="text-xs4 font-normal text-[#555259]">Credit/Debit Details</h5>
                <div className="flex items-center">
                    <button
                        type="button"
                        className="bg-[#F5F5FA] font-bold text-xs h-9 text-[#555259] border-2 border-[#E9EDF4] py-1 px-4 rounded-[9px] mr-2.5"
                        style={{
                            border: '2px solid #E9EDF4',
                        }}
                        data-testid="filter-btn"
                        data-bs-toggle="modal"
                        data-bs-target="#filtermodal"
                        onClick={() => setFilterModal(true)}
                    >
                        Filter
                    </button>
                    <div className="relative mr-2">
                        <label htmlFor="search" />
                        <input
                            type="text"
                            name="search"
                            id="search"
                            className="w-[230px] h-[35px] bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px]"
                            placeholder="Search"
                            value={searchValue}
                            onChange={(e) => {
                                setsearchValue(e.target.value);
                            }}
                            autoComplete="off"
                        />
                        <img src="/images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px] cursor-pointer" />
                    </div>
                    <div className="mr-2 dropdown relative" ref={buttonRef}>
                        <button
                            type="button"
                            id="exportDropdown"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            data-testid="export-btn"
                            disabled={creditDebitList.length === 0 || emptyData || loading}
                            className={`dropdown-toggle h-[35px] text-xs2 font-semibold text-[#555259] w-[79px] border border-[#555259] rounded-lg flex items-center justify-center ${creditDebitList.length === 0 || emptyData || loading ? 'opacity-50 cursor-not-allowed' : ''}`}
                            onClick={() => showExport()}
                        >
                            {exportLoading ? <ThreeDots width={30} height={24} /> : 'Export'}
                        </button>
                        <ul className={`dropdown-menu min-w-[80px] absolute ${exportClick === true ? 'show' : 'hidden'} bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999]`} aria-labelledby="exportDropdown">
                            <li className="mx-[18px] pb-1.5 mt-5 hover:bg-[#F2F2F3] hover:rounded export">
                                <a
                                    className={`dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 ${exportLoading ? 'opacity-70 cursor-not-allowed' : ''}`}
                                    href="#"
                                    data-testid="csv-btn"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        if (!exportLoading) {
                                            setexportSelected('csv');
                                        }
                                    }}
                                >
                                    CSV
                                </a>
                            </li>
                            <li className="mx-[18px] pb-1.5 hover:bg-[#F2F2F3] hover:rounded">
                                <a
                                    className={`dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 ${exportLoading ? 'opacity-70 cursor-not-allowed' : ''}`}
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        if (!exportLoading) {
                                            setexportSelected('pdf');
                                        }
                                    }}
                                    data-testid="pdf-btn"
                                >
                                    PDF
                                </a>
                            </li>
                            <li className="mx-[18px] pb-1.5 mb-3 hover:bg-[#F2F2F3] hover:rounded">
                                <a
                                    className={`dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 ${exportLoading ? 'opacity-70 cursor-not-allowed' : ''}`}
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        if (!exportLoading) {
                                            setexportSelected('xlsx');
                                        }
                                    }}
                                    data-testid="excel-btn"
                                >
                                    Excel

                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            {loading ? <CreditDebitListSkeleton />
                : (
                    <div>
                        {creditDebitList.length > 0 && (
                            <CreditDebitListing
                                setCreditDebitList={setCreditDebitList}
                                creditDebitList={creditDebitList}
                                sortType={sortType}
                                setsortType={setsortType}
                                emptyData={emptyData}
                                setEmptyData={setEmptyData}
                                searchValue={searchValue}
                                handleFetchCreditDebitDetails={handleFetchCreditDebitDetails}
                            />
                        )}
                        {creditDebitList.length > 0 && (
                            <Pagination
                                handlePageClick={handlePageClick}
                                List={creditDebitList}
                                currentPage={currentPage}
                                totalPage={totalPage}
                            />
                        )}
                        {filterModal && (
                            <FilterModal
                                filterModal={filterModal}
                                setFilterModal={setFilterModal}
                                Filter={Filter}
                                setFilter={setFilter}
                                filterValue={filterValue}
                                setfilterValue={setfilterValue}
                                handleFilter={handleFilter}
                                handleFetchCreditDebitDetails={handleFetchCreditDebitDetails}
                                selected={selected}
                                setselected={setselected}
                                SetSuccessMessage={SetSuccessMessage}
                            />
                        )}
                        {emptyData && (
                            <EmptyScreen
                                search="yes"
                                text="no Credit/Debit Details"
                                buttonRequired={false}
                                all={debouncedSearch.length > 0 ? 'under searched term' : 'found'}
                            />
                        )}
                    </div>
                )}
        </div>
    );
}

export default ManageCreditDebitDetails;
